import * as React from 'react';
import FormLabel from 'modules/FormLabel';
import { FormikErrors } from 'formik';

interface FormInputWrapperProps {
  label?: React.ReactElement | string;
  description?: string;
  required?: boolean;
  disabled?: boolean;
  error?: any;
  // error?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
  children?: any;
}

const FormInputWrapper = ({ label, description, required, disabled, error, children }: FormInputWrapperProps) => {
  return (
    <>
      {label && (
        <FormLabel required={required} disabled={disabled}>
          {label}
        </FormLabel>
      )}
      {children}
      {description && !error && (
        <ul className="parsley-description-list filled" id="parsley-id-11">
          <li className="parsley-required">{description}</li>
        </ul>
      )}
      {error && (
        <ul className="parsley-errors-list filled" id="parsley-id-11">
          <li className="parsley-required">{error}</li>
        </ul>
      )}
    </>
  );
};

export default FormInputWrapper;
